import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from '@/config'
import iView from 'view-design'
import VCharts from 'v-charts'
import { directive as clickOutside } from 'v-click-outside-x'
import './registerServiceWorker'
import importDirective from '@/directive'
import './index.less'
import '@/assets/icons/iconfont.css'
import { myMixin } from './libs/mixin'
// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock');

Vue.use(iView, {
    transfer: true
})
Vue.use(VCharts)
Vue.mixin(myMixin)
/**
 * @description 注册admin内置插件
 */
Vue.directive('clickOutside', clickOutside)
/**
 * 注册指令
 */
importDirective(Vue)
Vue.config.productionTip = false
Vue.prototype.$config = config
Vue.prototype.$initIndex = process.env.VUE_APP_FLAG == 'test' ? 0 : 1
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
